var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "vue-need-bootstrap h100" }, [
    _c(
      "div",
      {
        staticClass: "d-flex justify-content-center w-100 h-100 overflow-auto",
      },
      [
        _c(
          "div",
          {
            staticClass: "d-flex flex-column h-100 w-100",
            class: { "mb-3": _setup.breadcrumbItems.length },
          },
          [
            _setup.breadcrumbItems.length
              ? _c("b-breadcrumb", { attrs: { items: _setup.breadcrumbItems } })
              : _vm._e(),
            _vm._v(" "),
            _c(_setup.CLoader, {
              attrs: { text: _setup.loader.text },
              model: {
                value: _setup.loader.value,
                callback: function ($$v) {
                  _vm.$set(_setup.loader, "value", $$v)
                },
                expression: "loader.value",
              },
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "app-container mt-3 d-flex flex-grow-1" },
              [
                _c(
                  "transition",
                  { attrs: { name: "fade", mode: "out-in" } },
                  [_c("router-view")],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }